/**
 * Heritage centralized delivery region filtering.
 * Shows the region matching the shopper country on product pages only.
 */
(function () {
  const userCountry = window.shopifyCountry || "GB";

  const DELIVERY_CONFIG = {
    countryMap: {
      GB: "uk",
      US: "usa",
      CA: "canada",
    },
    euCountries: new Set([
      "AT",
      "BE",
      "BG",
      "HR",
      "CY",
      "CZ",
      "DK",
      "EE",
      "FI",
      "FR",
      "DE",
      "GR",
      "HU",
      "IE",
      "IT",
      "LV",
      "LT",
      "LU",
      "MT",
      "NL",
      "PL",
      "PT",
      "RO",
      "SK",
      "SI",
      "ES",
      "SE",
    ]),
    defaultRegion: "row",
  };

  function isProductPage() {
    return (
      document.body.classList.contains("template-product") ||
      document.querySelector(".product-block") !== null
    );
  }

  function resolveRegionCode(country) {
    if (DELIVERY_CONFIG.countryMap[country]) {
      return DELIVERY_CONFIG.countryMap[country];
    }

    if (DELIVERY_CONFIG.euCountries.has(country)) {
      return "eu";
    }

    return DELIVERY_CONFIG.defaultRegion;
  }

  function hideReturnsOnProductPage() {
    if (!isProductPage()) {
      return;
    }

    document
      .querySelectorAll('[data-region="returns"], #returns-exchanges')
      .forEach((element) => {
        element.style.display = "none";
      });
  }

  function filterDeliveryRegions() {
    if (!isProductPage()) {
      return;
    }

    const regionCode = resolveRegionCode(userCountry);
    const regions = document.querySelectorAll(".heritage-delivery-rates [data-region]");

    if (!regions.length) {
      return;
    }

    regions.forEach((element) => {
      const matches = element.getAttribute("data-region") === regionCode;
      element.style.display = matches ? "" : "none";
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    filterDeliveryRegions();
    hideReturnsOnProductPage();
  });
})();
